import React from 'react';
import Divider from '@material-ui/core/Divider';
import BCLButton from '../../../common/Buttons/BCLButton';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { DASHBOARD_SURVEY_PATH } from '../../../../constants/paths';
import {UNITS, FUEL_TYPE, PAGE_EVENT_NAMES, INSIGHTS_PAGES, HOME_SURVEY} from '../../../../constants/common' 
import analytics from '../../../../img/analytics.svg';
import { getFuelUnit } from '../../../../helpers/helper';
import { trackEvent } from '../../../../helpers/analyticsHelper';

class MonthlySummaryDetails extends React.Component{

    goToSurvey() {
        this.props.history.push(DASHBOARD_SURVEY_PATH);
        trackEvent(this.props.userId, PAGE_EVENT_NAMES.INSIGHTS, {
            btnClicked : HOME_SURVEY,
            tab : INSIGHTS_PAGES.MONTHLY_SUMMARY
        })
    }
    render(){
        const {monthlySummaryData, configColors} = this.props;
        
        const currentMSData = monthlySummaryData.monthlySummaryDataArray[monthlySummaryData.monthlySummaryActiveIndex];
        const isNSM = this.props.configsData["isNSM"] === "true";
        return(
            <>
                { currentMSData.cost ?
                <>    
                    <div className="ms-details-gimpses">
                        <div>{this.props.translationsData["MONTHLY_SUMMARY.DETAILS.USAGE_HEADER"]}<strong>{currentMSData.consumption} {getFuelUnit(this.props.configsData.fuelType)}</strong></div>
                        {
                            this.props.configsData.fuelType === FUEL_TYPE.ELECTRIC &&
                            <div>{this.props.translationsData["MONTHLY_SUMMARY.DETAILS.BILL_HEADER"]}<strong>{this.props.configsData.currency_unit}{currentMSData.cost}</strong></div>
                        }
                    </div>
                    { isNSM ? '' :
                    currentMSData.highestWeekendConsumptionDate && currentMSData.highestWeekdayConsumptionDate &&
                    <div className="ms-details-analytics">
                        <div className="heighest-consumption weekday">
                            <img src={analytics} alt=""/>
                            <div className="details">
                                <div className="description">
                                {this.props.translationsData["MONTHLY_SUMMARY.DETAILS.HIGHEST_WEEKEND_HEADER"]}
                                </div>
                                <div className="day">
                                    <strong>{currentMSData.highestWeekendConsumptionDate}</strong>
                                </div>
                            </div>
                        </div>
                        <Divider/>
                        <div className="heighest-consumption weekend">
                            <img src={analytics} alt=""/>
                            <div className="details">
                                <div className="description">
                                {this.props.translationsData["MONTHLY_SUMMARY.DETAILS.HIGHEST_WEEKDAY_HEADER"]}
                                </div>
                                <div className="day">
                                    <strong>{currentMSData.highestWeekdayConsumptionDate}</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                    }
                </> : ''}                
                <div className="home-profile-text">
                    {this.props.translationsData["MONTHLY_SUMMARY.DETAILS.COMPLETE_SURVEY_TEXT"]}
                </div>
                <BCLButton btnVariant="outlined"
                    btnText={this.props.translationsData["COMMON.HOME_SURVEY_BUTTON_TEXT"]}
                    btnBackground={`rgb(${configColors['--color_54']})`}
                    hoverColor={`rgb(${configColors['--color_54']})`}
                    btnTextTransform = "none"
                    btnTextSize="14px"
                    btnTextColor={`rgb(${configColors['--color_1']})`}
                    borderColor={`rgb(${configColors['--color_1']})`}
                    btnWidth="100%"
                    onClick={() => this.goToSurvey()}>
                </BCLButton>
            </> 
        )
    }
}

const mapStateToProps = state => { 
    return{
        monthlySummaryData : state.monthlySummaryData,
        translationsData : state.translationsData.data,
        configsData : state.configs.data,
        userId: state.userIdentityDetails.userId
    }
}

export default withRouter(connect(mapStateToProps)(MonthlySummaryDetails));